exports.tabType = [
  {
    label: '设备',
    value: 'device'
  },
  {
    label: '工具',
    value: 'tool'
  },
  {
    label: '角色',
    value: 'role'
  },
  {
    label: '场景',
    value: 'scene'
  },
  {
    label: '系统',
    value: 'system'
  }
]
